export function getFocusedIndex(rows: HTMLElement[]) {
  return rows.findIndex(row => row === document.activeElement)
}

export function getRows(role: string) {
  return Array.from(document.querySelectorAll<HTMLElement>(`[data-role='${role}']`))
}

function getNextRow(rows: HTMLElement[]) {
  const current = getFocusedIndex(rows)
  if (current === rows.length - 1) return 0
  return current === -1 ? 0 : Math.min(current + 1, rows.length - 1)
}

function getPrevRow(rows: HTMLElement[]) {
  const current = getFocusedIndex(rows)
  if (current === 0) return rows.length - 1
  return current === -1 ? 0 : Math.max(current - 1, 0)
}

export function focusNextRow(rows: HTMLElement[]) {
  const next = getNextRow(rows)
  rows[next].focus()
}

export function focusPrevRow(rows: HTMLElement[]) {
  const next = getPrevRow(rows)
  rows[next].focus()
}
